<template>
  <div>
    <div width="100%" style="background-color: #CCC; border-radius: 3px; padding-left: 10px; border: 1px solid;">
      <span class="font-weight-bold text-uppercase h-4">{{ aItems[nIndex].Pregunta }}</span>
    </div>
    <div width="50%" style="border: 1px solid; border-radius:3px; padding-left: 10px;">
      <div style="display: flex;">
        <v-container>
          <v-row dense>
            <v-col v-for="(oImage, j) in aImage" :key="j" sm="3" md="3" lg="3" xl="3">
              <div id="sImgReference" >
                <img class="aFotos" style="width: 180px; height: 180px;" :src="oImage"/>
                <br>
                <span>Nombre: {{ oDataProcess[0].Asistente.trim() }}</span>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
  </div>
</template>
<script>
import axiosServices from '@/services/axiosServices.js'
export default {
  props: {
    aItems: Array,
    nIndex: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    this.getURLImage()
  },
  data () {
    return {
      sURL: '',
      oDataProcess: {},
      aImage: [],
    }
  },
  methods: {
    getURLImage () {
      let sParams = 'sPath=Path_imagenes'
      axiosServices.getConfiguration('FormDinamicCorreo_Path', false, sParams).then(getPath => {
        this.sURL = getPath.aData.Observacion
        this.proccessData()
      })
    },
    toDataURL (src, callback) {
      var img = new Image()
      img.crossOrigin = 'Anonymous'
      img.onload = function() {
        var canvas = document.createElement('canvas')
        var context = canvas.getContext('2d')
        canvas.height = this.naturalHeight
        canvas.width = this.naturalWidth
        context.drawImage(this, 0, 0)
        var dataURL = canvas.toDataURL('image/jpeg', 1.0)
        callback(dataURL)
      }
      img.src = src
    },
    proccessData () {
      if (("Detalle" in this.aItems[this.nIndex]) && this.aItems[this.nIndex].Detalle !== null) {
        let Details = JSON.parse(this.aItems[this.nIndex].Detalle.toString().trim().replace(/(\r\n|\n|\r)/gm, ""))
        this.oDataProcess = Details
        if (Details.length > 0) {
          Details.forEach(objFirma => {
            if ("Firma" in objFirma) {
              this.toDataURL(`${this.sURL}${objFirma.Firma}`, this.setValue)
            }
          })
        }
      }
    },
    setValue(sBase64) {
      this.aImage.push(sBase64)
      this.resize()
    },
    resize () {
      if (window.addEventListener) {  // all browsers except IE before version 9
        window.addEventListener("resize", onResizeEvent, true);
      }
      function onResizeEvent() {
        let divImgElement = document.getElementById("sImgReference")
        let newWidth = divImgElement.clientWidth
        let aImgsRenders = document.getElementsByClassName("aFotos")
        aImgsRenders.forEach(oElementImg => {
          oElementImg.style.width = `${newWidth}px`
          oElementImg.style.height = `${newWidth}px`
        })
      }
    },
  }
}
</script>
